export const RESPONSIVE_SPLIT_QUERY_TEST_NAME = 'PdpRespSplitQuery_May2025';
export const MOBILE_SPLIT_QUERY_TEST_NAME = 'PdpMobileSplitQuery_June2025';
